import { HttpContextToken } from '@angular/common/http';
import { Validator, ValidatorSchema } from '@libs/utilities/validator';

/** Keep authentication handling, but let the requesting feature present recoverable errors. */
export const NG_HTTP_HANDLE_ERRORS_LOCALLY: HttpContextToken<boolean> = new HttpContextToken(() => false);


/**------------------------------------------------------
 * Interfaces
 */
export interface INgHttpAbstractConfig {
	SERVER_URL		: string;
	SERVER_LIVE_URL	: string;
}


/**------------------------------------------------------
 * Config Schema
 */
export class NgHttpAbstractClass implements ValidatorSchema<INgHttpAbstractConfig> {
	SERVER_URL		= Validator.String().isNotEmpty();
	SERVER_LIVE_URL	= Validator.String().isNotEmpty();
}
